import type { MutableRefObject, RefObject } from "react";
import { Combobox } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import type { ActiveOption } from "./types";

interface TopicInputProps {
  activeOption: ActiveOption;
  buttonRef: RefObject<HTMLButtonElement | null>;
  isCreatingTopic: boolean;
  maxTopicsAllowed: number;
  onChange: (value: string) => void;
  onCreateTopic: (topicName: string) => void;
  onRemoveAllTopics: () => void;
  onRemoveLastTopic: () => void;
  searchInputRef: MutableRefObject<HTMLInputElement | null>;
  value: string;
}

export const TopicInput = ({
  value,
  onChange,
  activeOption,
  maxTopicsAllowed,
  isCreatingTopic,
  onCreateTopic,
  onRemoveLastTopic,
  onRemoveAllTopics,
  searchInputRef,
  buttonRef,
}: TopicInputProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key, ctrlKey: isCtrlPressed, metaKey: isMetaPressed } = event;

    if ((isCtrlPressed || isMetaPressed) && key === "Backspace") {
      onRemoveAllTopics();
    } else if (key === "Backspace" && value.length === 0) {
      onRemoveLastTopic();
    } else if (
      key === "Enter" &&
      activeOption === "create" &&
      !isCreatingTopic &&
      value.trim().length > 0
    ) {
      event.preventDefault();
      onCreateTopic(value);
    }
  };

  return (
    <Combobox.Input
      className="min-w-[200px] flex-1 border-none bg-transparent p-0 px-1 py-[5px] text-sm focus:ring-0"
      ref={searchInputRef}
      value={value}
      placeholder={t("quick_post_v2.topics.search", {
        count: maxTopicsAllowed,
      })}
      onChange={event => onChange(event.target.value)}
      onFocus={() => buttonRef.current?.click()}
      onKeyDown={handleKeyDown}
    />
  );
};
